import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import axios from "axios";
import Encryption from "../api/Encryption";

const LANGUAGE = {
  "en-US": "en",
  en: "en",
  es: "es",
};

const backendOptions = {
  loadPath: (lng) => {
    const url = `${process.env.REACT_APP_BASE_URL}language/web-language-object`;
    return { url, lng };
  },
  allowMultiLoading: false,
  crossDomain: true,
  request: async (_options, url, _payload, callback) => {
    if (!url?.url) {
      callback(new Error("Missing translation URL"), null);
      return;
    }

    try {
      const res = await axios.post(url.url, {
        language: LANGUAGE[url?.lng] ?? "en",
      });
      const data = Encryption.decrypt(res.data);
      callback(null, { data: data?.data ?? {}, status: 200 });
    } catch (error) {
      // Avoid unhandled promise rejection; allow app to load without remote strings
      if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.warn("[i18n] Failed to load translations:", error?.message);
      }
      callback(null, { data: {}, status: 200 });
    }
  },
};

i18n
  .use(detector)
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    // resources,
    language: "en",
    fallbackLng: "en", //language to use if translations in user language are not available
    interpolation: {
      escapeValue: false, // not needed for react!!
      prefix: "{",
      suffix: "}",
    },

    // supportedLngs: ['en', 'ar','gu','hi'],
    backend: backendOptions,
  });

export default i18n;
